import { PlaygroundActionType } from './playground-action.type';
import { PlaygroundMode } from '../enums/mode.enum';
import { merge } from 'lodash';
import { ENUM_DOMAIN_STATUS } from '../enums/domain-status.enum';
import { deepUpdate } from '../utils/deep-update';
import { findEmptyCardIndex, getNewCardPosition, updateCardAtIndex } from '../utils/card/card-reducer-helpers';
import { DEFAULT_APPEARANCE_SETTINGS } from '../constants/default-appearance-settings.constants';
export const initialState = {
    mode: PlaygroundMode.PREVIEW,
    page_usernames: [],
    payload: {
        _id: '',
        username: '',
        name: '',
        title: '',
        bio: '',
        cta_button: {
            label: '',
            url: '',
        },
        banner: {
            text: '',
            url: '',
        },
        domain: '',
        domain_status: ENUM_DOMAIN_STATUS.PENDING,
        custom_hostname_id: '',
        ownership_verification: {
            type: '',
            name: '',
            value: '',
        },
        cards: [],
        mailing_integrations: [],
        page_settings: {
            title: '',
            description: '',
            show_page_in_search_engines: true,
            favico_url: '',
            social_image_url: '',
        },
        appearance_settings: DEFAULT_APPEARANCE_SETTINGS,
        subscription: null,
    },
    actions: [],
    create_new_page: false,
    isCardDraggable: true,
};
export const playgroundReducer = (state, action) => {
    var _a, _b;
    switch (action.type) {
        case PlaygroundActionType.SET_INIT_PAYLOAD:
            return Object.assign(Object.assign({}, state), { payload: Object.assign(Object.assign({}, state.payload), action.payload) });
        case PlaygroundActionType.SET_PAYLOAD:
            return Object.assign(Object.assign({}, state), { payload: merge({}, state.payload, action.payload), actions: [...state.actions, action.type] });
        case PlaygroundActionType.GET_LINKIE_USERNAMES:
            return Object.assign(Object.assign({}, state), { page_usernames: action.payload });
        case PlaygroundActionType.CLEAR_PAYLOAD:
            return Object.assign(Object.assign({}, state), { payload: initialState.payload, create_new_page: false });
        case PlaygroundActionType.CREATE_NEW_LINKIE:
            return Object.assign(Object.assign({}, state), { create_new_page: true, payload: initialState.payload });
        case PlaygroundActionType.CHANGE_MODE:
            return Object.assign(Object.assign({}, state), { mode: action.payload });
        case PlaygroundActionType.SET_CARD: {
            const currentCards = state.payload.cards || [];
            const emptyCardIndex = findEmptyCardIndex(currentCards);
            let updatedCards;
            if (emptyCardIndex !== -1) {
                updatedCards = updateCardAtIndex(currentCards, emptyCardIndex, action.payload);
            }
            else {
                const newPosition = getNewCardPosition(currentCards);
                updatedCards = [Object.assign(Object.assign({}, action.payload), { position: newPosition }), ...currentCards];
            }
            return Object.assign(Object.assign({}, state), { payload: Object.assign(Object.assign({}, state.payload), { cards: updatedCards }), actions: [...state.actions, action.type] });
        }
        case PlaygroundActionType.SET_CARD_PAYLOAD:
            return Object.assign(Object.assign({}, state), { payload: Object.assign(Object.assign({}, state.payload), { cards: (_a = state.payload.cards) === null || _a === void 0 ? void 0 : _a.map((card) => {
                        if ((card._id || card.client_id) === action.payload.cardId) {
                            const fullPath = Object.keys(action.payload)[0];
                            const pathArray = fullPath.split('.').slice(2);
                            const fieldValue = Object.values(action.payload)[0];
                            return deepUpdate(card, pathArray, fieldValue);
                        }
                        return card;
                    }) }), actions: [...state.actions, action.type] });
        case PlaygroundActionType.DELETE_CARD:
            return Object.assign(Object.assign({}, state), { payload: Object.assign(Object.assign({}, state.payload), { cards: (_b = state.payload.cards) === null || _b === void 0 ? void 0 : _b.filter((card) => (card._id || card.client_id) !== action.payload) }), actions: [...state.actions, action.type] });
        case PlaygroundActionType.REORDER_CARDS:
            return Object.assign(Object.assign({}, state), { payload: Object.assign(Object.assign({}, state.payload), { cards: action.payload.map((card, index) => (Object.assign(Object.assign({}, card), { position: action.payload.length - 1 - index }))) }), actions: [...state.actions, action.type] });
        case PlaygroundActionType.REORDER_CARDS_AND_POSTS_SETTINGS:
            return Object.assign(Object.assign({}, state), { payload: Object.assign(Object.assign({}, state.payload), { cards: action.payload.cards, posts_settings: state.payload.posts_settings
                        ? Object.assign(Object.assign({}, state.payload.posts_settings), { position: action.payload.posts_settings_position }) : state.payload.posts_settings }), actions: [...state.actions, action.type] });
        case PlaygroundActionType.CLEAR_ACTIONS:
            return Object.assign(Object.assign({}, state), { actions: [] });
        case PlaygroundActionType.SET_IS_CARD_DRAGGABLE:
            return Object.assign(Object.assign({}, state), { isCardDraggable: action.payload });
        case PlaygroundActionType.SET_POSTS_SETTINGS:
            return Object.assign(Object.assign({}, state), { payload: Object.assign(Object.assign({}, state.payload), { posts_settings: action.payload }), actions: [...state.actions, action.type] });
        default:
            return state;
    }
};
//# sourceMappingURL=playground-reducer.js.map